import React from "react"
import { withStyles } from '@material-ui/core';
import { getEventsValue } from "./utils"
import TabBar from "./FilterBar"


const styles = () => ({
  selectedPlaceholder: {
    marginTop: 2,
    fontSize: 14,
  },
  placeholder: {
    color: "rgba(51, 51, 51, 0.75)",
    fontSize: 14,
    marginTop: 2,
    fontWeight: 600
  }
})


const EventsFilterBar = ({ firstFilterValue, thirdFilterValue, eventsSelectedByTimeProperties, propertiesOfOrg, monthRange, subOrgDetails, handleChangeProperty, handleMonthRange, handleResetClick, classes, tabIndex, single, ...props }) => {
  const [events, setEvents] = React.useState([])
  const [properties, setProperties] = React.useState([])
  const [eventsDropDown, setEventsDropDown] = React.useState([])


  React.useEffect(() => {
    const {
      properties,
      events,
      eventsDropDown
    } = getEventsValue(firstFilterValue, thirdFilterValue, eventsSelectedByTimeProperties);
    setEvents(events);
    setProperties(properties)
    setEventsDropDown(eventsDropDown)
    let obj = {
      id: properties,
      list: events
    }
    if (typeof props.filterSelectedCallback == "function") {
      props.filterSelectedCallback(properties, monthRange, [obj])
    }
  }, [firstFilterValue, thirdFilterValue, eventsSelectedByTimeProperties, monthRange, tabIndex])

  const handleEventsChange = (selected) => {
    setEvents(selected);
    let obj = {
      id: properties[0],
      list: selected
    }
    if (typeof props.handleChangeEvents == "function") {
      props.handleChangeEvents([obj])
    }
  }

  const getCustomLabelForProperties = (selected, count, name) => {
    if (!name) {
      return <div className={classes.placeholder}>Property</div>
    }
    return <div className={classes.selectedPlaceholder}><strong>{name}</strong></div>
  }


  const getCustomLabelForEvents = (selected, count, name) => {
    if (events.length == 0) {
      return <div className={classes.placeholder}>Event</div>;
    }
    return (
      <div className={classes.selectedPlaceholder}>
        {single ? (
          <strong>{name}</strong>
        ) : (
          <strong>
            {events.length < 2 ? "Event" : "Events"} ({events.length})
          </strong>
        )}
      </div>
    );
  };

  return (
    <div>
      <TabBar
        firstFilterData={{
          type: "selector",
          optionValue: propertiesOfOrg,
          placeholder: "Property",
          searchPlaceHolder: "Enter property name here...",
          onChange: handleChangeProperty,
          singleSelect: true,
          value: properties,
          selectAllText: "Select all properties",
          getCustomLabel: getCustomLabelForProperties
        }}
        secondFilterDate={{
          type: "dateRange",
          position: "left",
          value: monthRange,
          handleApply: handleMonthRange,
          timezoneString: subOrgDetails.timezoneString
        }}
        thirdFilterData={{
          type: "selector",
          optionValue: eventsDropDown,
          placeholder: "Event",
          searchPlaceHolder: "Enter event name here...",
          onChange: handleEventsChange,
          multiple: !single,
          singleSelect: single,
          value: events,
          selectAllText: "Select all Events",
          getCustomLabel: getCustomLabelForEvents
        }}
        handleResetClick={handleResetClick}
        tabIndex={tabIndex}
        {...props}
      />
    </div>
  )
}

export default withStyles(styles)(EventsFilterBar)